import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAllEcoFriendly,
  StatusEcoFriendly,
} from "../../../../features/admin/master/ecofriendly/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const ecofriendly = useSelector((state) => state.masters.ecofriendly);

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  const fetch = async (page = ecofriendly?.current_page) => {
    await dispatch(
      GetAllEcoFriendly({
        name: name,
        page: page,
        per_page: ecofriendly?.per_page,
      }),
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      setModalMessage("Deleted Successfully");
      setModalShow(true);
      await fetch();
      return true;
    } catch (error) {
      setModalMessage("Delete Failed");
      setModalShow(true);
      console.error(error);
      return false;
    }
  };

  const toggleStatus = async (id) => {
    try {
      const res = await dispatch(StatusEcoFriendly(id));
      if (res.payload?.data?.success) {
        await fetch();
        setModalShow(true);
        return true;
      }
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    ecofriendly,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    modalMessage,
    modalShow,
    setModalShow,
  };
};
